import { defineMessages } from 'react-intl';

export const messages: {
	dateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dateLabel: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-input.preview.date-label',
		defaultMessage: 'Date',
		description: 'Fallback label for the date input field in preview mode',
	},
});
